import { useEffect, useRef, useState } from 'react';

// Observe once. Keep ordinary semantic content mounted while enhancing it on approach.
export default function useNearViewport(rootMargin = '600px') {
    const ref = useRef(null);
    const [near, setNear] = useState(false);
    useEffect(() => {
        if (!('IntersectionObserver' in window)) { setNear(true); return; }
        const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
                setNear(true);
                observer.disconnect();
            }
        }, { rootMargin });
        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, [rootMargin]);
    return [ref, near];
}
